import React from 'react';
import LogoFlyingS from 'canvas-core-react/lib/LogoFlyingS';
import LogoScotiabankEn from 'canvas-core-react/lib/LogoScotiabankEn';
import Margin from 'canvas-core-react/lib/Margin';
import './header.scss';

const Header = () => {
  return (
    <Margin side="bottom" xs={72} sm={72} md={90} lg={90}>
      <div className="header-app">
        <div>
          <LogoFlyingS id="logo-scotia-s" />
          <LogoScotiabankEn  id="logo-scotia-en" className="logo-scotiabank-app" />
        </div>
      </div>
    </Margin>
  );
};

export default Header;
